import React, { useCallback } from "react";

import { styled, useMediaQuery, useTheme } from "@mui/material";
import AccordonCommon from "../../CommonScreens/AccordonCommon";
import { Drawer } from "@mui/material";
import { InteractiveList } from "./List/InteractiveList";
import UpdateIcon from "../../../Assets/Images/notification_update_icon.svg";
import SurveyIcon from "../../../Assets/Images/notification_survey_icon.svg";
import NoticeIcon from "../../../Assets/Images/notice-icon.svg";
import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import CloseIcon from "@material-ui/icons/Close";

const RightTabWrapper = styled("div")(({ theme }) => {
  return {
    ".web_tooltiop_member_container": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: " flex-end",
      position: "fixed",
      width: "100%",
      // height: "70vh",
      overflowY: "scroll",
      top: "65px",
      "-ms-overflow-style": "none",
      "::-webkit-scrollbar": {
        display: "none",
      },
    },
    ".web_tag_main_div": {
      // position: "fixed",
      zIndex: 1,
    },
    ".web_tag": {
      boxShadow:
        "rgb(50 50 93 / 25%) 0px 0px 0px 0px inset, rgb(0 0 0 / 30%) 0px 22px 26px -15px inset",
      backgroundColor: "#5f52a1",
      height: "11vw",
      width: "4vw",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "center",
      padding: "1.5vw 0",
      cursor: "pointer",
    },
    ".web_patch_icon": {
      objectFit: "contain",
      width: "1.76vw",
      marginBottom: "1em",
    },
    ".web_patch_text": {
      marginTop: "0.2vw",
      width: "13vw",
      height: "2vw",
      transform: "rotate(-90deg)",
      fontSize: "1.3vw",
      fontWeight: 500,
      color: "#ffffff",
    },
    // Responsive
    [theme.breakpoints.down(1024)]: {
      ".web_tooltiop_member_container": {
        display: "none",
      },
    },
  };
});

const StyleWrapper = styled("div")(({ theme }) => {
  return {
    ".label-right": {
      textTransform: "none",
    },
    ".MuiListItem-root:hover": {
      background: "none !important",
      ".MuiListItemText-root .MuiListItemText-secondary span": {
        color: "rgb(78, 78, 78) !important",
      },
    },
    ".AnnouncInnerPage": {
      ".MuiListItem-root:hover": {
        background: "#eee !important",
        ".MuiListItemText-root .MuiListItemText-secondary span": {
          color: "rgb(78, 78, 78) !important",
        },
      },
    },
    ".AnnuocmentPopup": {
      borderRadius: "30px!important",
      border: "2px solid #41b5c2!important",
      backgroundColor: "#41b5c2!important",
      boxShadow:
        "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
      padding: "6px 16px",
      fontSize: "0.875rem",
      minWidth: 64,
      fontWeight: 500,
      lineHeight: 1.75,
      width: "13vw",
      letterSpacing: "0.02857em",
      textTransform: "uppercase",
      color: "#fff",
    },
    [theme.breakpoints.down(475)]: {
      ".AnnuocmentPopup": {
        width: "40vw",
      },
    },
  };
});

export const RightTabs = (props) => {
  const { ...rest } = props;
  const theme = useTheme();
  const [Height, setHeight] = React.useState(0);
  const ref = React.useRef(null);
  const [open, setOpen] = React.useState(false);
  const div_ref = React.useRef(null);
  const [btnValue, setBtnValue] = React.useState(1);
  const [isShow, setIsShow] = React.useState(false);
  const [popupData, setPopupData] = React.useState([]);

  React.useEffect(() => {}, []);
  React.useLayoutEffect(() => {
    setHeight(ref?.current?.offsetTop);
  }, []);

  const toggleDrawer = (open, value) => (event) => {
    setBtnValue(value);
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpen(open);
  };

  function dateformat(date) {
    const enrollmentDate = new Date(date);
    const nowdate = new Date();

    const formatedDate =
      enrollmentDate.getMonth() +
      "/" +
      enrollmentDate.getDate() +
      "/" +
      enrollmentDate.getFullYear();
    const todayDate =
      nowdate.getMonth() +
      "/" +
      nowdate.getDate() +
      "/" +
      nowdate.getFullYear();

    const hr = enrollmentDate.getHours();

    if (formatedDate !== todayDate) {
      return enrollmentDate.getMonth() + "/" + enrollmentDate.getDate();
    } else {
      if (hr === 0) {
        return enrollmentDate.getMinutes() + "mins";
      } else if (hr > 12) {
        return `${hr}:${enrollmentDate.getMinutes()} PM`;
      } else {
        return `${hr}:${enrollmentDate.getMinutes()} AM`;
      }
    }
  }

  function dateformat1(date, type) {
    if (!date) return "";

    const enrollmentDate = new Date(date);

    const formatDateMonth = new Intl.DateTimeFormat("en-US", {
      dateStyle: type,
    });
    return formatDateMonth.format(enrollmentDate);
  }

  const handleClick =
    (data) => {
      setIsShow(true);
      setPopupData(data);
    }

  const handleClose = () => {
    setIsShow(false);
  };

  const handleOk = () => {
    setIsShow(false);
    window.open(
      "https://carynhealth-enrollment-flow.s3.us-east-2.amazonaws.com/placeholder.pdf"
    );
  };

  const DialogPopup = ({isShow, popupData, handleClose, handleOk}) => {
    return (
      <Dialog open={isShow} maxWidth="xs">
        <DialogTitle
          sx={{
            color: "#5f2161",
            // fontFamily: "Roboto",
            fontSize: 25,
            fontWeight: "500",
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: 1,
            letterSpacing: 0.15,
          }}
        >
          {popupData?.description}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 5,
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent>
          <div style={{ fontWeight: "bold" }}>{popupData?.date}</div>
          <div
            dangerouslySetInnerHTML={{
              __html: popupData?.message ? popupData?.message : "",
            }}
          />
        </DialogContent>
        <StyleWrapper>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button className="AnnuocmentPopup" autoFocus onClick={handleClose}>
              OK
            </Button>
            <Button className="AnnuocmentPopup" onClick={handleOk}>
              VIEW DOCUMENTS
            </Button>
          </DialogActions>
        </StyleWrapper>
      </Dialog>
    );
  };

  return (
    <div ref={ref}>
      <RightTabWrapper {...rest}>
        <div className="web_tooltiop_member_container">
          <div className="web_tag_main_div">
            <div className={"web_tag"} onClick={toggleDrawer(true, 1)}>
              {/* <img src={require('./../../../Assets/Images/my_health.svg')} className="web_patch_icon" /> */}
              <div className="web_patch_text">RESOURCES</div>
            </div>
            <div className={"web_tag"} onClick={toggleDrawer(true, 2)} style={{backgroundColor:'#f48366'}}>
              {/* <img src={require('./../../../Assets/Images/my_health.svg')} className="web_patch_icon" /> */}
              <div className="web_patch_text" style={{ marginTop: "1.3vw" }}>
                NOTIFICATIONS
              </div>
            </div>
            <div className={"web_tag"} onClick={toggleDrawer(true, 3)} style={{backgroundColor:'#eda532'}}>
              {/* <img src={require('./../../../Assets/Images/my_health.svg')} className="web_patch_icon" /> */}
              <div className="web_patch_text" style={{ width: "10vw" }}>
                NOTICES
              </div>
            </div>
          </div>
        </div>
      </RightTabWrapper>

      <Drawer
        anchor={"right"}
        open={open}
        style={{
          zIndex: 100,
          marginTop: Height,
          width: btnValue === 1 ? "auto" : "400px",
        }}
        onClose={toggleDrawer(false)}
      >
        <div style={{ padding: 30 }}>
          {btnValue === 1 ? (
            <AccordonCommon
              clientId={props.data.clientId}
              clientName={props.data.clientName}
              agentId={props.data.agentId}
              disable={true}
            />
          ) : btnValue === 2 ? (
            <InteractiveList
              onClick={console.log}
              list={[
                {
                  image: UpdateIcon,
                  label: "Update",
                  labelRight: dateformat("2021-10-18T12:26:58.000+00:00"),
                  description:
                    "Your Commissions Report for the month of September has been emailed to you. ",
                },
                {
                  image: SurveyIcon,
                  label: "Survey",
                  labelRight: dateformat("2022-12-12T12:26:58.000+00:00"),
                  description:
                    "Please complete the small business survey to help us understand relevant issues and expectations that have been gathered by you during sales calls.",
                },
              ]}
            />
          ) : (
            <InteractiveList
              onClick={handleClick}
              list={[
                {
                  image: NoticeIcon,
                  label: "NOTICE",
                  labelRight: dateformat1(
                    "2021-10-18T12:26:58.000+00:00",
                    "medium"
                  ),
                  description: "New Products",
                  message: `<html><body>
                        <p>We’ve added new products effective today, October 1, 2023 and therefore updated our Resources to reflect the details.</p>
                        <ul> 
                          <li>Advanced Health Tools Add-On</li>
                          <li>Essential Health Add-On</li> 
                        </ul>
                        <p>The most up to date version of our resources will always be available in your Agent Portal.</p>
                        <br/> 
                        <p>Thank you<br/> CarynHealth</p>
                        </body>
                      </html>`,
                  urlPath: "notices",
                  type: "NOTICE",
                  date: dateformat1("2021-10-18T12:26:58.000+00:00", "long"),
                },
                {
                  image: NoticeIcon,
                  label: "NOTICE",
                  labelRight: dateformat1(
                    "2021-12-12T12:26:58.000+00:00",
                    "medium"
                  ),
                  description: "Health Plan Change Notice",
                  message: `<html><body>
                            <p>We’ve made updates to the Health Plan Benefits and wanted to share the details with you.</p>
                            <p>Effective, December 13, 2022, new members who enroll into any Health Plan Product will have access to Multiplan / PHCS Practitioner & Ancillary Network and new members who enroll will be able to claim expenses related to office visits.</p>            
                            <p>Other changes are related to typographical errors and clarifications to existing Plans.</p>
                            <p>The most up to date version of our SBC will always be available in your Agent Portal.</p>
                            <br/> <p>Thank you<br/> CarynHealth</p>       
                            </body>
                            </html>`,
                  urlPath: "notices",
                  type: "NOTICE",
                  date: dateformat1("2021-12-12T12:26:58.000+00:00", "long"),
                },
              ]}
            />
          )}
        </div>
      </Drawer>
      {isShow && (
        <DialogPopup
          isShow={isShow}
          popupData={popupData}
          handleClose={handleClose}
          handleOk={handleOk}
        />
      )}
    </div>
  );
};
